/* Galloperly EU legal guarantee notice: opens #GlyLegalPanel from any [data-gly-legal-trigger].
   Desktop (fine pointer, >= 750px): popover, opens on hover, click pins it open.
   Touch / mobile: bottom sheet with backdrop + scroll lock. Escape / outside click / close button closes.
   Triggers can live inside <template>-moved markup (ss-tabs-block), so everything is document-delegated. */
(function () {
  if (window.__glyLegalInit) return;
  window.__glyLegalInit = true;

  var TRIGGER = '[data-gly-legal-trigger]';
  var desktopMq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
  var layer = null;
  var panel = null;
  var activeTrigger = null;
  var pinned = false;
  var hideTimer = null;
  var closeTimer = null;

  function ready() {
    layer = layer || document.getElementById('GlyLegalLayer');
    panel = panel || document.getElementById('GlyLegalPanel');
    return !!(layer && panel);
  }

  function isOpen() {
    return layer && !layer.hidden && layer.classList.contains('is-open');
  }

  // Images sit in a hidden layer, so native lazy-loading would only start on open (blank header on hover).
  function loadImages() {
    if (!ready()) return;
    panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }
  if (document.readyState === 'complete') setTimeout(loadImages, 1500);
  else window.addEventListener('load', function () { setTimeout(loadImages, 1500); });

  // Popover goes on whichever side of the trigger has more room and is capped to it, so it never covers the trigger.
  function position(trigger) {
    var r = trigger.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var gap = 8;
    var edge = 12;
    var below = vh - r.bottom - gap - edge;
    var above = r.top - gap - edge;
    var placeBelow = below >= 360 || below >= above;
    panel.style.maxHeight = Math.max(200, Math.min(640, placeBelow ? below : above)) + 'px';
    var w = panel.offsetWidth;
    var h = panel.offsetHeight;
    var left = Math.min(Math.max(edge, r.left), vw - w - edge);
    var top = placeBelow ? r.bottom + gap : r.top - gap - h;
    panel.style.left = left + 'px';
    panel.style.top = Math.max(edge, top) + 'px';
  }

  function open(trigger, viaClick) {
    if (!ready()) return;
    clearTimeout(hideTimer);
    clearTimeout(closeTimer);
    if (viaClick) pinned = true;
    if (activeTrigger === trigger && isOpen()) return;
    if (activeTrigger && activeTrigger !== trigger) activeTrigger.setAttribute('aria-expanded', 'false');
    activeTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');

    loadImages();
    var desktop = desktopMq.matches;
    layer.classList.toggle('is-popover', desktop);
    layer.classList.toggle('is-sheet', !desktop);
    layer.hidden = false;
    if (desktop) {
      position(trigger);
    } else {
      panel.style.left = '';
      panel.style.top = '';
      panel.style.maxHeight = '';
      document.documentElement.classList.add('gly-legal-lock');
      void panel.offsetHeight; // commit the off-screen start state so the slide-up transitions
    }
    requestAnimationFrame(function () {
      layer.classList.add('is-open');
    });
    if (viaClick || !desktop) panel.focus({ preventScroll: true });
  }

  function close(returnFocus) {
    if (!layer || layer.hidden) return;
    clearTimeout(hideTimer);
    pinned = false;
    layer.classList.remove('is-open');
    document.documentElement.classList.remove('gly-legal-lock');
    var t = activeTrigger;
    activeTrigger = null;
    if (t) t.setAttribute('aria-expanded', 'false');
    closeTimer = setTimeout(function () {
      if (!layer.classList.contains('is-open')) layer.hidden = true;
    }, 300);
    if (returnFocus && t) t.focus({ preventScroll: true });
  }

  function scheduleClose() {
    if (pinned) return;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      close(false);
    }, 220);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(TRIGGER);
    if (trigger) {
      e.preventDefault();
      if (activeTrigger === trigger && pinned) close(false);
      else open(trigger, true);
      return;
    }
    if (e.target.closest('[data-gly-legal-close]')) {
      close(true);
      return;
    }
    if (isOpen() && !e.target.closest('#GlyLegalPanel')) close(false);
  });

  document.addEventListener('mouseover', function (e) {
    if (!desktopMq.matches) return;
    var trigger = e.target.closest(TRIGGER);
    if (trigger) {
      if (!pinned || activeTrigger === trigger) open(trigger, false);
      return;
    }
    if (e.target.closest('#GlyLegalPanel')) clearTimeout(hideTimer);
  });

  document.addEventListener('mouseout', function (e) {
    if (!desktopMq.matches || !e.target.closest(TRIGGER + ', #GlyLegalPanel')) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest(TRIGGER + ', #GlyLegalPanel')) return;
    scheduleClose();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close(true);
  });

  window.addEventListener('resize', function () {
    if (!isOpen()) return;
    if (layer.classList.contains('is-popover') !== desktopMq.matches) close(false);
    else if (activeTrigger && desktopMq.matches) position(activeTrigger);
  });

  window.addEventListener(
    'scroll',
    function () {
      if (!isOpen() || !layer.classList.contains('is-popover')) return;
      if (pinned && activeTrigger) position(activeTrigger);
      else close(false);
    },
    { passive: true }
  );
})();
